import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  pageTitle: () => __(translations.forgotPasswordPage.pageTitle, 'Forgot password'),
  backTo: () => __(translations.forgotPasswordPage.backTo, 'Back to login'),
  reset: () => __(translations.forgotPasswordPage.reset, 'Reset'),
};
